const endpoints = {
    QUERY_GRAPHQL: '/catalog-agg-query/graphql',
    CHECK_OFFER_ELIGIBILITY: '/cem/ecom/eligibility-management/v1/fiber-availability',
    SHOPPING_CART: '/shopping-cart/v3/shoppingCart',
    UPDATE_VALIDATE_SHOPPING_CART: '/mobily-shopping-cart-management/api/update-and-validate',
    CAPTURE_DATA: '/checkout-api/v3/checkout/captureData',
    BFF_LOGIN_INITIATE_OTP: '/cem/bff/otp/v1/send',
    BFF_LOGIN_VALIDATE_OTP: '/cem/bff/otp/v1/validate',
    BFF_LOGIN_RESEND_OTP: '/cem/bff/otp/v1/resend',
    POST_PRODUCT_ORDER: '/cem/order-generator/ftth-lead/v1/postProductOrder',
    CHECKOUT_STRUCTURE: '/checkout-api/v3/checkout/structure',
    GET_MAIN_AND_AROUND_ODB: '/api/v1/dp/gis/GetMainAndAroundODB',
    QUALIFYING_PRODUCT_OFFERS: '/product-offering-qualification-management/v3/qualifyProducts?parentCategoryfilter=mobily_fiber_free_addons&isProductDetailRequired=true&fields=po:id,name,specCharValueUse.name,specCharValueUse.specCharacteristicValue.value',
    ADD_TO_CART: (scId: string, ocId: string) => `/shopping-cart/v3/shoppingCart/${scId}/offerContainer/${ocId}/cartItem`,
};
export default endpoints;